import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Slices } from '../../constans/state';

export interface IToastSliceBody {
  title: string;
  description: string;
  mode: 'warning' | 'error' | 'success' | 'information';
  type?: string;
}

export interface IToastSlice {
  toastData: IToastSliceBody | null;
}

const initialState = {
  toastData: null,
};

export const toastSlice = createSlice({
  name: Slices.ToastSlice,
  initialState,
  reducers: {
    showToast: (state: IToastSlice, action: PayloadAction<IToastSliceBody>) => {
      state.toastData = action.payload;
    },
    hideToast: (state: IToastSlice) => {
      state.toastData = null;
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;

export default toastSlice.reducer;
